import React, { useState } from 'react';

interface StarRatingProps {
    totalStars?: number;
    initialRating: number;
    onRatingChange?: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({
    totalStars = 5,
    initialRating = 0,
    onRatingChange,
}) => {
    const [rating, setRating] = useState<number>(initialRating);
    const [hoverRating, setHoverRating] = useState<number>(0);

    const handleClick = (star: number) => {
        setRating(star);
        if (onRatingChange) {
            onRatingChange(star);
        }
    };

    const handleMouseEnter = (star: number) => {
        setHoverRating(star);
    };

    const handleMouseLeave = () => {
        setHoverRating(0);
    };

    const renderStars = () => {
        return Array.from({ length: totalStars }, (_, index) => {
            const star = index + 1;
            const isFilled = star <= (hoverRating || rating);
            return (
                <span
                    key={star}
                    onClick={() => handleClick(star)}
                    onMouseEnter={() => handleMouseEnter(star)}
                    onMouseLeave={handleMouseLeave}
                    style={{ cursor: 'pointer', fontSize: '20px', color: isFilled ? '#ffc107' : '#e4e5e9' }}
                >
                    ★
                </span>
            );
        });
    };

    return <div>{renderStars()}</div>;
};

export default StarRating;
